/**
 * @generated SignedSource<<405c593de9839696cb063c660e534a45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvestigationsTabTestsTreeCountFragment$data = {
  readonly count: number | null;
  readonly " $fragmentType": "ProjectInvestigationsTabTestsTreeCountFragment";
};
export type ProjectInvestigationsTabTestsTreeCountFragment$key = {
  readonly " $data"?: ProjectInvestigationsTabTestsTreeCountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvestigationsTabTestsTreeCountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvestigationsTabTestsTreeCountFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "type": "TestOccurrences",
  "abstractKey": null
};

(node as any).hash = "774fc6d6ddc59958d2dd12a0e9321134";

export default node;
